import API from '@/services/http'
import { RightItemType } from '@/bizComponents/FeeTotal'

export interface FeeItem {
  type: 'cod_handle_fee' | 'import_taxes'
  amount: number
  currencyCode: string
  /**
   * 是否为负数
   */
  amountNegative: boolean
}

export interface FeeObject {
  expressTypeCode: string | null
  shippingResults: {
    freight: number
    currencyCode: string
    originalFreight: number
    discountFreight: number
    /**保费，标准货币单位*100 */
    premium?: number
    /**计费失败原因 */
    failReason?: string
    /**渠道自定义信息，透传给上游, json格式
arriveDaysRange:预估到达时间 eg: 1-4 
"{\"arriveDaysRange\":\"1-4\", \"sendle\":{\"planName\":\"路线\"}}"
*/
    channelCustomParam?: string
    channelCustomParamParse?: {
      arriveDaysRange?: string
      sendle?: {
        planName?: string
      }
    }
    feeItems: FeeItem[]
  }[]
  rightsResults?: RightItemType[]
}
export interface FeeState {
  shippingFeeResults: FeeObject[]
}

export interface FeePayload {
  feeMetadatas: FeePayloadItem[]
}

export interface FeePayloadItem {
  expressTypeCode?: string
  metadatas?: FeePayloadMetadatasItem[]
  oneshipNo?: string
  appId?: string
}

export type IPartitionInfo = {
  pickupType?: number
  deliveryType?: number
  valueOfGoods?: number
  valueOfGoodsCurrency?: string
  taxes?: Array<{
    taxType: string
    taxNo: number
  }>
}

export interface FeePayloadMetadatasItem {
  metadataId?: string
  weightUnit?: string
  weight?: string | number
  length?: string | number
  width?: string | number
  height?: string | number
  lengthUnit?: string
  currencyCode?: string
  senderAddress?: ExpressListAddressName
  consigneeAddress?: ExpressListAddressName
  oneshipNo?: string
  appId?: string
  partitionInfo?: IPartitionInfo
}

export interface ExpressListAddressName {
  countryCode?: string
  provinceName?: string
  cityName?: string
  districtName?: string
  zipCode?: string
}
/**
 * 运费试算
 * @param payload
 * @returns
 */
export const getFeeList = async (payload: FeePayload) => {
  const res = await API.admin.post<FeeState>('/api/fee/trial/calculate', payload)
  try {
    res.data?.shippingFeeResults?.forEach((item) => {
      item?.shippingResults?.forEach((result) => {
        try {
          result.channelCustomParamParse = JSON.parse(result.channelCustomParam)
        } catch (error) {}
      })
    })
  } catch (error) {}
  return res
}

/**
 * 
 * @param data 
 * @returns 
 * @deprecated
 */
export function calculateCustomFreightSingle(data?: OneshipSellerFreightRequest['freightParams'][0]) {
  return API.post<{ data: CalculateRes }>('/api/fee/setting/calculate', {
    withoutExceptionAborted: true,
    freightParams: [{ ...data, bizId: 0 }],
  }).then((res) => {
    return {
      ...res.data?.data?.accepted?.[0],
      ...{
        errorCode: res.data?.data?.rejected?.[0]?.code,
        errorMsg: res.data?.data?.rejected?.[0]?.msg,
      },
    }
  })
}

interface OneshipShippingAddressVo {
  /**国家编码（约束：countryCode must not be blank） */
  countryCode: string
  /**一级行政区名称，比如省份/州 */
  provinceName?: string
  /**二级行政区名称，比如城市 */
  cityName?: string
  /**三级行政区名称，比如区/县 */
  districtName?: string
  /**四级行政区名称，比如乡/镇/街道 */
  townName?: string
  /**邮编 */
  zipCode?: string
  /**详细地址1 */
  address?: string
  /**详细地址2 */
  addressTwo?: string
  /**寄件人/收件人名字 */
  name?: string
  /**寄件人/收件人手机 */
  mobile?: string
}

interface OneshipSellerFreightReqParamVo {
  /**请求计价参数唯一Id，响应结果会一一对应 */
  bizId?: string
  /**商家id */
  sellerId?: string
  /**服务产品编码 */
  expressTypeCode?: string
  /**该参数仅在商家使用oneship运费时生效。
指定使用的价格版本，为空则使用最新 */
  priceBaseVersion?: string
  /**渠道预估运费 */
  channelCalculateFee?: number
  /**单位重量 */
  weightUnit?: string
  /**重量 */
  weight?: string | number
  /**长度 单位默认cm */
  length?: string
  /**宽度 单位默认cm */
  width?: string
  /**高度 单位默认cm */
  height?: string
  /**距离,km */
  distance?: string
  /**该参数仅在商家使用oneship运费时生效。
期望使用的优惠规则，为空则使用最新 */
  freightPromotionSeq?: string
  /**寄件地址 */
  senderAddress?: OneshipShippingAddressVo
  /**收件人地址 */
  consigneeAddress?: OneshipShippingAddressVo
}

export interface OneshipSellerFreightRequest {
  /**不异常中断流程(默认中断) */
  withoutExceptionAborted?: boolean
  /**运费计算请求参数 */
  freightParams?: OneshipSellerFreightReqParamVo[]
}

interface RejectedRespVo {
  /**请求唯一id */
  bizId?: string
  /**错误编码 */
  code?: string
  /**错误信息 */
  msg?: string
}

interface SellerFreightAcceptedVo {
  /**请求计价参数唯一Id，响应结果会一一对应 */
  bizId?: string
  /**商家id */
  sellerId?: string
  /**服务产品编码 */
  expressTypeCode?: string
  /**运费,标准币种 */
  freight?: number
  /**原始费用 */
  originalFreight?: number
  /**货币币种 */
  currencyCode?: string

  chargeMode: string
}

export interface CalculateRes {
  /**运费计算成功结果集 */
  accepted?: SellerFreightAcceptedVo[]
  /**运费计算失败结果集 */
  rejected?: RejectedRespVo[]
}
